export const ROLES = "roles";
export const SKILLS = "skills";
export const HOBBIES = "hobbies";
export const EXPERIENCES = "experiences";
export const EDUCATIONS = "educations";
export const LANGUAGES = "languages";
export const TRANSLATIONS = "translations";
export const PROFILEVERSIONS = "profileVersions";
export const OBJ_NAME_PROFILEVERSION = "profileVersion";